// extracted by mini-css-extract-plugin
export default {"root":"_1oYo7","body-wrapper":"Oj0LG","bodyWrapper":"Oj0LG","big":"DqADk","postfix":"_2EOGM","small":"_3aok0","multiline":"_3z69b","body-node":"_1t6jA","bodyNode":"_1t6jA"};